var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64597 2.77728C7.23642 1.74091 8.76489 1.74091 9.35533 2.77728L14.4701 11.7549C15.0439 12.7622 14.297 14 13.1154 14H2.88591C1.70429 14 0.957387 12.7622 1.53123 11.7549L6.64597 2.77728ZM8.66728 11.3333C8.66728 11.7015 8.3688 12 8.00061 12C7.63242 12 7.33394 11.7015 7.33394 11.3333C7.33394 10.9651 7.63242 10.6667 8.00061 10.6667C8.3688 10.6667 8.66728 10.9651 8.66728 11.3333ZM8.50061 6C8.50061 5.72386 8.27675 5.5 8.00061 5.5C7.72447 5.5 7.50061 5.72386 7.50061 6V9.33333C7.50061 9.60948 7.72447 9.83333 8.00061 9.83333C8.27675 9.83333 8.50061 9.60948 8.50061 9.33333V6Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.3ec13c099603c06d4006fb443740b855.svg";